export default class SliderImprovements {
	start() {
		if ($('.ENABLE_SLIDER_CONTROL_IMPROVEMENTS').length === 0) {
			return;
		}
		this.sliderImprovements();
	}

	sliderImprovements() {
		$(window).on('load', () => {
			$('.et_pb_slider').each((i, slider) => {
				const sliderObj = $(slider);
				this.anchors2Buttons(sliderObj);
				this.addSliderAttributes(sliderObj);
			});
		});
	}

	anchors2Buttons(slider) {
		this.arrows2Button(slider);
		this.bullets2Button(slider);
	}

	arrows2Button(slider) {
		const sliderArrows = slider.find('.et-pb-slider-arrows');
		//ARROWS - <a> to <button>
		if (sliderArrows.find('a').length) {
			sliderArrows.html(sliderArrows.html().replace(/<a\b/g, '<button')
				.replace(/<\/a>/g, '</button>'));
			this.addArrowsTriggerEvent(slider);
		}
	}

	bullets2Button(slider) {
		const slides = slider.find('.et_pb_slide');
		const sliderControllersAnchor = slider.find(slider.find('.et-pb-controllers a'));
		// BULLETS - <a> to <button>
		if (sliderControllersAnchor.length && slides.find('.et_pb_slide')) {
			sliderControllersAnchor.each((k) => {
				slider.find('.et-pb-controllers')
					.append(`<button>${(k + 1)}</button>`);
			});

			const buttonStyle = this.getInitialButtonsStyle(slider);
			this.setButtonStyle(slider, buttonStyle);
			//copy the bullets <a> events to <button>
			const events = $._data(slider.find('.et-pb-controllers a:first')
				.get(0), 'events');
			if (typeof events !== 'undefined') {
				const buttons = slider.find('.et-pb-controllers button');
				buttons.bind(events.click[0].type, events.click[0].handler);
			}
			//remove the <a> tag after their events was saved and applied to buttons
			sliderControllersAnchor.remove();
			//create functionality for buttons similar with a tag
			slider.find('.et-pb-controllers button:first')
				.addClass('et-pb-active-control');
			const observer = new MutationObserver((mutations) => {
				mutations.forEach(() => {
					const activeSlideIndex = slider.find('.et-pb-active-slide').index();
					this.createBulletsFunctionality(slider, activeSlideIndex);
				});
			});
			observer.observe(slider[0], {
				attributes: 'true',
				attributeFilter: ['class'],
			});
		}
	}

	createBulletsFunctionality(slider, activeSlideIndex) {
		slider.find('.et-pb-active-control')
			.removeClass()
			.attr('aria-selected', 'false');
		slider.find(`.et-pb-controllers button:eq(${activeSlideIndex})`)
			.addClass('et-pb-active-control')
			.attr('aria-selected', 'true');
	}

	setButtonStyle(slider, style) {
		$(style).insertAfter('style:last');
	}

	getInitialButtonsStyle(slider) {
		const computedStyle = window
			.getComputedStyle(slider.find('.et-pb-controllers a:last').get(0));
		const simpleColor = computedStyle.getPropertyValue('background-color');
		const simpleOpacity = computedStyle.getPropertyValue('opacity');
		const computedActiveStyle = window
			.getComputedStyle(slider.find('.et-pb-controllers a.et-pb-active-control').get(0));
		const activeColor = computedActiveStyle.getPropertyValue('background-color');
		const activeOpacity = computedActiveStyle.getPropertyValue('opacity');
		let css = '';
		css += `background-color: ${simpleColor} !important; `;
		css += `opacity: ${simpleOpacity} !important; `;
		let cssActive = '';
		cssActive += `background-color: ${activeColor} !important; `;
		cssActive += `opacity: ${activeOpacity} !important; `;
		const cssSliderSelector = `.${slider.attr('class').replace(/ /g, '.')}`;
		const buttonStyle = `<style id="neewstyle">${cssSliderSelector} .et-pb-controllers button {${css}}
			${cssSliderSelector} .et-pb-controllers .et-pb-active-control {${cssActive}}</style>`;
		return buttonStyle;
	}

	addSliderAttributes(slider) {
		slider.attr('aria-roledescription', 'carousel');
		slider.attr('aria-label', 'Slideshow');
		$('.et-pb-arrow-prev')
			.attr('aria-label', 'Previous Slide')
			.attr('role', 'button');
		$('.et-pb-arrow-next')
			.attr('aria-label', 'Next Slide')
			.attr('role', 'button');
		const nrSlides = slider.find('.et_pb_slide').length;
		slider.find('.et-pb-controllers button')
			.each((i, circle) => {
				$(circle).attr('aria-label', `Slide ${i + 1}`)
					.attr('aria-selected', 'false');
			});
		slider.find('.et-pb-active-control')
			.attr('aria-selected', 'true');
		slider.find('.et_pb_slide').each((i, slide) => {
			$(slide).attr('role', 'group')
				.attr('aria-roledescription', 'slide')
				.attr('aria-label', `${i + 1} of ${nrSlides}`);
		});
	}

	addArrowsTriggerEvent(slider) {
		slider.find('.et-pb-arrow-prev')
			.keypress((event) => {
				if (jQuery.inArray(event.which, [13, 32]) !== -1) {
					slider.find('.et-pb-slider-arrows .et-pb-arrow-prev')
						.trigger('click');
				}
			});
		slider.find('.et-pb-arrow-next')
			.keypress((event) => {
				if (jQuery.inArray(event.which, [13, 32]) !== -1) {
					slider.find('.et-pb-slider-arrows .et-pb-arrow-next')
						.trigger('click');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/slider/controllers/slider-improvements.js